import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "cn";

import { USAGE_TEXTS as TEXTS } from "./texts.ts";
import {
  describeCost,
  formatTokens,
  totalTokens,
  type UsageTotals,
} from "./usage.ts";
import { UsageBreakdown } from "./UsageBreakdown.tsx";

/**
 * Lo que lleva gastado la conversación abierta, en su cabecera (2.4.2).
 *
 * Va pegado al título y no se encoge: el título es lo que se trunca. Enseña el
 * coste --que es lo que se vigila-- y los tokens van en el desglose.
 */
export function ConversationUsage({ usage }: { usage: UsageTotals }) {
  const cost = describeCost(usage.costUsd, usage.unpricedCalls);

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          className={cn(
            "shrink-0 cursor-default rounded-full border px-2 py-0.5 text-xs whitespace-nowrap tabular-nums",
            "text-muted-foreground hover:text-foreground",
          )}
        >
          {cost.kind === "unknown"
            ? TEXTS.conversation.unpriced(formatTokens(totalTokens(usage)))
            : cost.short}
        </button>
      </TooltipTrigger>
      <TooltipContent side="bottom" align="start">
        <UsageBreakdown usage={usage} title={TEXTS.conversation.title} />
      </TooltipContent>
    </Tooltip>
  );
}
